import { createContext } from 'react';

const GoogleMapsContext = createContext({
  googleMapsIsLoaded: false,
  googleMapsError: undefined,
});

export default GoogleMapsContext;
